import React from 'react';
import PropTypes from 'prop-types';
import { t } from 'i18next';
import { ActionButton } from '../../ReactComponent/Modal/css';
import AlertModal from '../../ReactComponent/Modal/AlertModal';
import { P } from '../../../theme/typographySitecore';
import { ErrorIcon, HeaderContainer } from './css';

const InvalidTokenModal = ({ isOpen, parentFields }) => {
  const onClose = () => {
    window.location.href = '/';
  };

  const header = () => (
    <HeaderContainer>
      <ErrorIcon />
      <div>{parentFields.invalidTokenModalHeader.value}</div>
    </HeaderContainer>
  );

  const content = () => (
    <P field={parentFields.invalidTokenModalSummary} />
  );

  const actions = () => (
    <ActionButton className="active" iconRightArrow onClick={onClose}>
      {t('Okay')}
    </ActionButton>
  );

  return (
    <AlertModal
      isOpen={isOpen}
      onClose={onClose}
      header={header}
      content={content}
      actions={actions}
    />
  );
};

InvalidTokenModal.propTypes = {
  isOpen: PropTypes.bool,
  parentFields: PropTypes.shape({
    invalidTokenModalHeader: PropTypes.shape({
      value: PropTypes.string,
    }),
    invalidTokenModalSummary: PropTypes.object,
  }),
};

export default InvalidTokenModal;
